<template>
  <div class="d-flex flex-row flex-nowrap align-center py-1 card-wrapper" :key="teacher.id">
    <div v-if="!$vuetify.breakpoint.mobile" class="image-wrapper mr-2">
      <img :src="avatar" alt="" />
    </div>
    <div class="d-flex, flex-column, flex-start">
      <div class="teacher-name">{{ teacher.name }}</div>
      <div class="teacher-info">
        {{ getSubject }}
        <span v-if="getSubject"> - </span>
        {{ getAcademicLevels }}
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash-es/get'

export default {
  props: {
    teacher: Object
  },
  computed: {
    avatar() {
      return get(this.teacher, 'avatar.url', require('@/assets/default-avatar.svg'))
    },
    getAcademicLevels() {
      if (get(this.teacher, 'academicLevels', null) && this.teacher.academicLevels.length) {
        let levelText = 'Cấp '
        let levelArr = []
        this.teacher.academicLevels.forEach(level => {
          switch (level.type) {
            case 'primary':
              levelArr.push(1)
              break
            case 'secondary':
              levelArr.push(2)
              break
            case 'high':
              levelArr.push(3)
              break
          }
        })
        levelArr = levelArr.sort()
        return (levelText += levelArr.join(', '))
      } else {
        return ''
      }
    },
    getSubject() {
      if (get(this.teacher, 'subjectGroup.title', '')) {
        return this.teacher.subjectGroup.title
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.card-wrapper {
  width: 100%;
}
.image-wrapper {
  width: 45px;
  min-width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
